import React from 'react';
import { Box, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  icon: ({ color }) => ({
    width: '1.5rem',
    height: '1.5rem',
    minWidth: '1.5rem',
    minHeight: '1.5rem',
    borderRadius: '8px',
    marginRight: '0.5rem',
    backgroundColor: color,
  }),
  label: ({ labelFontSize }) => ({
    fontFamily: 'NotoSans-Bold',
    fontSize: labelFontSize ? labelFontSize : '1rem',
    color: '#7d86a9',
  }),
}));

const StatusCom = ({ text, color, labelFontSize }) => {
  const classes = useStyles({ color, labelFontSize });
  return (
    <Box display="flex" alignItems="center">
      <div className={classes.icon} />
      <div className={classes.label}>{text}</div>
    </Box>
  );
};

export default StatusCom;
